import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/games/breathing-exercises/_components/breathing-game.tsx");
